export const HackerIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    {/* Hat */}
    <path d="M7 6c0-2 2-4 5-4s5 2 5 4v2H7V6z"/>
    {/* Hat brim */}
    <rect x="4" y="8" width="16" height="1.5" rx="0.75"/>
    {/* Sunglasses */}
    <rect x="7" y="10" width="3.5" height="2.5" rx="1.25"/>
    <rect x="13.5" y="10" width="3.5" height="2.5" rx="1.25"/>
    {/* Nose bridge */}
    <rect x="10.5" y="11" width="3" height="0.8"/>
    {/* Suit collar left */}
    <path d="M6 14L12 18v6H6c-2 0-4-2-4-4v-6z"/>
    {/* Suit collar right */}
    <path d="M18 14L12 18v6h6c2 0 4-2 4-4v-6z"/>
    {/* Tie */}
    <rect x="11" y="18" width="2" height="6"/>
  </svg>
);
